import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';
import './CSS/Global.css';
import './CSS/Local.css'
import logo from '../Components/img/100BILLION_TECH_name.png';
import { toast } from "react-toastify";
import img1 from "./img/100BILLION_ICON.png"

const Header = ({ cartItems, fetchCartDataMainPage }) => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false); // State for login modal
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false); // State for logout confirmation modal
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    // const [login, setLogin] = useState(false);
    const [dropdownOpen, setDropdownOpenFull] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate("")
    const [shakeHeader, setShakeHeader] = useState(false);
    const [prevCartLength, setPrevCartLength] = useState(cartItems.length);

    const login = JSON.parse(localStorage.getItem("login")) || false;
    useEffect(() => {
        if (cartItems.length > prevCartLength) {
            setShakeHeader(true);
            setTimeout(() => setShakeHeader(false), 500);
        }
        setPrevCartLength(cartItems.length);
    }, [cartItems.length]);


    useEffect(() => {
        // Retrieve login data from localStorage on mount
        const savedUserEmail = localStorage.getItem('userEmail');
        if (savedUserEmail) {
            setUserEmail(savedUserEmail);
            setIsLoggedIn(true);
        }
        if (login && login.emplyee_ID) {
            fetchCartDataMainPage();
        }
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    const toggleDropdown1 = () => {
        setDropdownOpenFull(!dropdownOpen);
    };

    const handleLoginSuccess = (email) => {
        setUserEmail(email);
        setIsLoggedIn(true);
        setModalOpen(false);
        localStorage.setItem('userEmail', email);
    };

    const handleLogout = () => {
        localStorage.removeItem('login');
        setIsLoggedIn(false);
        setUserEmail('');
        setLogoutModalOpen(false);
        showToast("Logout successfully", "success");
    };

    const showToast = (message, type = "info") => {
        toast(message, {
            type,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    };

    return (
        <header className="header">
            <div className="header-ham-logo">
                {/* Hamburger icon for mobile menu */}


                {/* Logo */}
                <div className="header-logo">
                    <Link to="/">
                        <img src={logo} alt="Logo" className="logo-img" />
                    </Link>
                </div>
            </div>
            <div className='headerenquiryhbtbest'>
                {
                    login ? (
                        <div className={`cart-container cart-container-mobile ${shakeHeader ? "shake-header" : ""}`}>
                            <div
                                onClick={() => navigate('/cart')} // Directly using an inline function
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fas fa-shopping-cart"></i>
                            </div>
                            {cartItems.length > 0 && <span 
                            onClick={() => navigate('/cart')} // Directly using an inline function
                                style={{ cursor: 'pointer' }}
                                className="cart-badge">{cartItems.length}</span>}
                        </div>
                    ) : null
                }
                <div className="header-login-mobile">
                    {login ? (
                        <div className="user-logged-in" ref={dropdownRef} onClick={toggleDropdown1}>

                            <img
                                src={
                                    img1
                                }
                                alt="User-Profile"
                                className="theme-color-blue-img img-fluid avatar avatar-50 avatar-rounded"
                                loading="lazy"
                            />


                            <span className="username">{login.full_name}</span>
                            <div className="dropdown">
                                <div className={`chevron-icon ${dropdownOpen ? 'rotate' : ''}`} >
                                    <i className="fas fa-chevron-down"></i>
                                </div>
                                <div className={`dropdownmenums ${dropdownOpen ? 'show' : ''}`}>

                                    {/* <Link to="/profile?tab=profileUserInfo"><i className="fas fa-user"></i> Profile</Link>
                                    <Link to="/orders"><i class="fa-solid fa-image"></i>Gallery</Link>
                                    <Link to="/orders"> <i className="fas fa-info-circle"></i>About</Link>
                                    <Link to="/orders"><i className="fa-solid fa-envelope"></i>Contact</Link> */}

                                    <Link
                                        onClick={handleLogout}
                                    ><i className="fas fa-user"></i> Logout</Link>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="user-not-logged-in" onClick={() => navigate("/login")}>
                            <p className="login-btn">
                                <i className="fas fa-sign-in-alt"></i> Login
                            </p>
                        </div>

                    )}
                </div>
                <button className="hamburger" onClick={toggleMenu}>
                    <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                </button>
            </div>
            {/* Navigation menu */}
            <nav className={`header-nav ${isMenuOpen ? 'active' : ''}`}>
                <ul className="nav-links">
                    <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
                    <li><Link to="/start-growing-your-business-at-₹1999/Month" onClick={() => setMenuOpen(false)}>OMS</Link></li>
                    {/* <li><Link to="" onClick={() => setMenuOpen(false)}>Online Store</Link></li> */}
                    <li className="dropdown" onMouseEnter={() => window.innerWidth > 768 && toggleDropdown()} onMouseLeave={() => window.innerWidth > 768 && toggleDropdown()}>
                        <Link to="#" className="dropdown-toggle" onClick={() => setDropdownOpen(!isDropdownOpen)}>Our Service  {isDropdownOpen ? <i style={{ marginLeft: "5px" }} className="fas fa-chevron-up"></i> : <i style={{ marginLeft: "5px" }} className="fas fa-chevron-down"></i>}</Link>
                        {isDropdownOpen && (
                            <ul className="dropdown-menu">
                                <li><Link to="/real-estate-website-development-service" onClick={() => setMenuOpen(false)}>Real Estate</Link></li>
                                <li><Link to="/website-development" onClick={() => setMenuOpen(false)}>Website Development</Link></li>
                                <li><Link to="/application-development" onClick={() => setMenuOpen(false)}>Application Development</Link></li>
                                <li><Link to="/get-your-online-store" onClick={() => setMenuOpen(false)}>E-commerce Website</Link></li>
                                <li><Link to="/google-ads" onClick={() => setMenuOpen(false)}>Google Ads</Link></li>
                                <li><Link to="/meta-ads" onClick={() => setMenuOpen(false)}>Meta Ads</Link></li>
                                <li><Link to="/digital-marketing" onClick={() => setMenuOpen(false)}>Digital Marketing</Link></li>
                            </ul>
                        )}
                    </li>
                    <li><Link to="/about-us" onClick={() => setMenuOpen(false)}>About</Link></li>
                    <li><Link to="/contact-us" onClick={() => setMenuOpen(false)}>Contact</Link></li>
                    {/* <li><Link to="/web-store" onClick={() => setMenuOpen(false)}>Web Store</Link></li> */}
                    {/* <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
                    <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
                    <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li> */}
                    {
                        login && (
                            <div onClick={() => navigate('/cart')} // Directly using an inline function
                            style={{ cursor: 'pointer' }} className={`cart-container cart-container-desktop ${shakeHeader ? "shake-header" : ""}`}>
                                <div
                                    onClick={() => navigate('/cart')} // Directly using an inline function
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className="fas fa-shopping-cart"></i>
                                </div>
                                {cartItems.length > 0 && <span  onClick={() => navigate('/cart')} // Directly using an inline function
                                style={{ cursor: 'pointer' }} className="cart-badge">{cartItems.length}</span>}
                            </div>
                        )
                    }
                    <button className='headergallerybtn'
                        onClick={() => navigate("/enquiry")}
                    ><i style={{ marginRight: "5px" }} class="fa-solid fa-message"></i> Enquiry
                    </button>
                    <button className='headergallerybtn1'
                        onClick={() => navigate("/enquiry")}
                    ><i style={{ marginRight: "5px" }} class="fa-solid fa-message"></i>Enquiry
                    </button>
                    <div className="header-login-desktop">
                        {login ? (
                            <div className="user-logged-in" ref={dropdownRef} onClick={toggleDropdown1}>

                                <img
                                    src={
                                        img1
                                    }
                                    alt="User-Profile"
                                    className="theme-color-blue-img img-fluid avatar avatar-50 avatar-rounded"
                                    loading="lazy"
                                />


                                <span className="username">{login.full_name}</span>
                                <div className="dropdown">
                                    <div className={`chevron-icon ${dropdownOpen ? 'rotate' : ''}`} >
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                    <div className={`dropdownmenums ${dropdownOpen ? 'show' : ''}`}>

                                        {/* <Link to="/profile?tab=profileUserInfo"><i className="fas fa-user"></i> Profile</Link>
                                    <Link to="/orders"><i class="fa-solid fa-image"></i>Gallery</Link>
                                    <Link to="/orders"> <i className="fas fa-info-circle"></i>About</Link>
                                    <Link to="/orders"><i className="fa-solid fa-envelope"></i>Contact</Link> */}

                                        <Link
                                            onClick={handleLogout}
                                        ><i className="fas fa-user"></i> Logout</Link>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="user-not-logged-in" onClick={() => navigate("/login")}>
                                <p className="login-btn">
                                    <i className="fas fa-sign-in-alt"></i> Login
                                </p>
                            </div>

                        )}
                    </div>
                </ul>
            </nav>
            {/* <div className="header-login">
                {isLoggedIn ? (
                    <div className="profile" onClick={toggleDropdown}>
                        <img src="https://picsum.photos/40/40" alt="Profile" className="profile-pic" />
                        <span className="profile-name">
                            {userEmail.length > 8 ? `${userEmail.slice(0, 8)}...` : userEmail}
                        </span>
                        <i className={`fas fa-chevron-down ${isDropdownOpen ? 'open' : ''}`}></i>
                        {isDropdownOpen && (
                            <div className="profile-dropdown">
                                <p className="full-profile-name">{userEmail}</p>
                                <Link to="/profile" onClick={() => setMenuOpen(false)}><i className="fa-solid fa-user"></i>Profile</Link>
                                <button onClick={() => setLogoutModalOpen(true)}><i className="fa-solid fa-right-from-bracket"></i>Logout</button>
                            </div>
                        )}
                    </div>
                ) : (
                    !isModalOpen && ( // Only show the login button when modal is not open
                        <button className="login-button" onClick={() => setModalOpen(true)}>Login</button>
                    )
                )}
            </div> */}

            <LoginModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} onLoginSuccess={handleLoginSuccess} />

            {isLogoutModalOpen && (
                <div className="logout-modal">
                    <div className="logout-modal-content">
                        <p>Are you sure you want to log out?</p>
                        <button onClick={() => setLogoutModalOpen(false)}>Cancel</button>
                        <button onClick={handleLogout}>Logout</button>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
